module.exports = __webpack_public_path__ + "img/help-account.986b3b9e.svg";